import { IconWrapper } from '../runtime';
export default IconWrapper('pdf-format', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 25 24",
      "fill": "none"
    }
  }, [h("path", {
    "attrs": {
      "d": "M0.5 3.75C0.5 1.67893 2.17893 0 4.25 0H20.75C22.8211 0 24.5 1.67893 24.5 3.75V20.25C24.5 22.3211 22.8211 24 20.75 24H4.25C2.17893 24 0.5 22.3211 0.5 20.25V3.75Z",
      "fill": 'url(#' + props.id + 'e6690312' + ')'
    }
  }), h("path", {
    "attrs": {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M10.25 5.25C10.25 4.62868 10.7537 4.125 11.375 4.125H15.5C18.1924 4.125 20.375 6.30761 20.375 9C20.375 11.6924 18.1924 13.875 15.5 13.875H8.75C7.71447 13.875 6.875 14.7145 6.875 15.75C6.875 16.7855 7.71447 17.625 8.75 17.625H10.25V15.375H12.5V18.75C12.5 19.3713 11.9963 19.875 11.375 19.875H8.75C6.47183 19.875 4.625 18.0282 4.625 15.75C4.625 13.4718 6.47183 11.625 8.75 11.625H15.5C16.9497 11.625 18.125 10.4497 18.125 9C18.125 7.55025 16.9497 6.375 15.5 6.375H12.5V10.125H10.25V5.25Z",
      "fill": "white"
    }
  }), h("defs", [h("linearGradient", {
    "attrs": {
      "id": props.id + 'e6690312',
      "x1": "0.5",
      "y1": "0",
      "x2": "24.5",
      "y2": "24",
      "gradientUnits": "userSpaceOnUse"
    }
  }, [h("stop", {
    "attrs": {
      "stop-color": "#FF5940"
    }
  }), h("stop", {
    "attrs": {
      "offset": "1",
      "stop-color": "#DE3030"
    }
  })])])]);
});